import React, { useState } from 'react';
import { FadeIn, Section, Button, FloralSeparator } from '../ui/Shared';
import { ChevronDown } from 'lucide-react';
export const TestimonialsSection = () => {
  const testimonials = [{
    text: "Sentía que algo estaba mal conmigo porque no estaba disfrutando como 'debería'. Este material me ayudó a entender que no era debilidad — eran cambios reales en mi cuerpo y mis emociones. Hoy me siento mucho más tranquila y segura como mamá.",
    name: 'Mariano G.',
    loc: 'Córdoba'
  }, {
    text: 'Con mi segundo bebé la depresión postparto me pegó fuerte. El Tomo 1 me dio claridad y el Tomo 2 estructura. Empecé con las rutinas de 10 minutos diarios y noté cambios en pocas semanas. Volví a sentir que tenía control sobre mi vida.',
    name: 'Camila F.',
    loc: 'Buenos Aires'
  }, {
    text: 'Lo que más me ayudó fueron las meditaciones. Las hacía cuando mi bebé dormía y eran mi momento de paz. Bajó muchísimo mi ansiedad nocturna y pude volver a descansar mejor.',
    name: 'Mayra M.',
    loc: 'Misiones'
  }, {
    text: 'Vivía con culpa constante. Pensaba que no estaba siendo suficiente. Este libro me enseñó a hablarme con más amor y a entender que pedir ayuda no me hace menos mamá.',
    name: 'Julieta R.',
    loc: 'Mendoza'
  }, {
    text: 'Lo compré porque estaba agotada emocionalmente. No sabía por dónde empezar. Tener todo organizado en dos tomos fue clave. No me sentí sola en ningún momento del proceso.',
    name: 'Andrea T.',
    loc: 'Corrientes'
  }, {
    text: 'Lo mejor fue sentir que alguien entendía exactamente lo que me pasaba. No es solo teoría, son herramientas prácticas que realmente aplicás en el día a día. Hoy me siento más presente con mi bebé y conmigo.',
    name: 'Natalia N., 26 años',
    loc: 'Rosario'
  }];
  return <Section className="bg-pink-light" data-id="element-205">
      <FadeIn data-id="element-206">
        <h2 className="text-4xl md:text-5xl text-center mb-10 italic" data-id="element-207">
          🌸 Lo que dicen las mamás que ya renacieron
        </h2>
      </FadeIn>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-208">
        {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-209">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-pink-border h-full flex flex-col" data-id="element-210">
              <div className="text-yellow-400 text-xl mb-3" data-id="element-211">⭐⭐⭐⭐⭐</div>
              <p className="italic text-brown-text/90 mb-4 flex-grow" data-id="element-212">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-213">
                <div className="w-10 h-10 bg-pink-light rounded-full flex items-center justify-center text-pink-deep" data-id="element-214">
                  🌸
                </div>
                <div data-id="element-215">
                  <p className="font-bold text-sm" data-id="element-216">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-217">{t.loc}</p>
                </div>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const GuaranteeSection = () => <Section className="bg-white" data-id="element-218">
    <FadeIn className="max-w-4xl mx-auto" data-id="element-219">
      <div className="border-2 border-dashed border-celeste-primary bg-celeste-light/30 rounded-3xl p-6 md:p-10 flex flex-col md:flex-row items-center gap-6" data-id="element-220">
        <div className="text-7xl md:text-8xl shrink-0" data-id="element-221">🛡️</div>
        <div data-id="element-222">
          <h2 className="text-3xl md:text-4xl font-bold text-celeste-deep mb-3 font-heading" data-id="element-223">
            Garantía Total — 7 Días, Sin Preguntas
          </h2>
          <div className="space-y-2 text-brown-text/90" data-id="element-224">
            <p className="font-bold" data-id="element-225">
              Queremos que entres con total tranquilidad.
            </p>
            <p data-id="element-226">Probá Renacer Después del Parto durante 7 días completos.</p>
            <p data-id="element-227">Explorá los tomos. Hacé los ejercicios. Sentí la diferencia.</p>
            <p data-id="element-228">
              Si por cualquier motivo no es para vos — nos escribís y te
              devolvemos el 100% de tu dinero.
            </p>
            <p data-id="element-229">Sin formularios complicados. Sin explicaciones. Sin demoras.</p>
            <p className="italic font-bold text-pink-deep mt-3" data-id="element-230">
              El riesgo es completamente nuestro. La transformación es
              completamente tuya.
            </p>
          </div>
        </div>
      </div>
    </FadeIn>
  </Section>;
export const FAQSection = () => {
  const faqs = [{
    q: '¿En qué formato recibo el material?',
    a: 'Todo el material es 100% digital. Recibís los PDF directamente en tu correo electrónico al instante de confirmar tu compra. Podés leerlos desde el celular, la tablet o la computadora — donde te resulte más cómodo.'
  }, {
    q: '¿Esto reemplaza la terapia psicológica o el tratamiento médico?',
    a: 'No. Renacer Después del Parto es un recurso de acompañamiento, psicoeducación y herramientas de bienestar emocional. Si estás atravesando una depresión postparto severa, siempre recomendamos complementarlo con atención profesional. Este material es un apoyo — no un reemplazo.'
  }, {
    q: '¿En cuánto tiempo voy a empezar a notar cambios?',
    a: 'Muchas mamás reportan sentir alivio y claridad desde el primer tomo. Los cambios más profundos suelen notarse entre la segunda y cuarta semana de aplicar las herramientas de manera consistente. No es magia — es un proceso real y gradual.'
  }, {
    q: '¿Incluye ejercicios prácticos o solo teoría?',
    a: 'Ambos tomos están cargados de ejercicios prácticos, plantillas, rituales diarios y meditaciones guiadas. No es solo teoría — es un método que aplicás en tu vida real, con recursos concretos para los momentos difíciles.'
  }, {
    q: '¿Necesito mucho tiempo al día para aplicarlo?',
    a: 'No. El programa está diseñado para mamás sin tiempo. Podés avanzar en 10–15 minutos diarios. Las herramientas son breves, aplicables y pensadas para la realidad caótica de una mamá en el postparto.'
  }, {
    q: '¿Y si me siento sola en el proceso?',
    a: 'El Tomo I está especialmente diseñado para que no te sientas sola. Además, podés contactarnos en cualquier momento si tenés dudas. Este proceso está pensado para acompañarte — no para dejarte a la deriva.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-celeste-light" data-id="element-231">
      <FadeIn data-id="element-232">
        <h2 className="text-4xl md:text-5xl text-center mb-8 italic" data-id="element-233">
          Tus preguntas, respondidas
        </h2>
      </FadeIn>

      <div className="max-w-3xl mx-auto bg-white rounded-2xl p-5 md:p-6 shadow-sm" data-id="element-234">
        {faqs.map((faq, i) => <div key={i} className="border-b border-pink-border last:border-0" data-id="element-235">
            <button className="w-full text-left py-4 flex items-center justify-between focus:outline-none group" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-236">
              <div className="flex items-center gap-4 pr-4" data-id="element-237">
                <span className="text-pink-primary font-bold text-xl group-hover:scale-110 transition-transform" data-id="element-238">
                  +
                </span>
                <span className="font-bold text-lg text-brown-text group-hover:text-pink-deep transition-colors" data-id="element-239">
                  {faq.q}
                </span>
              </div>
              <ChevronDown className={`w-5 h-5 text-pink-primary transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-240" />
            </button>
            <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === i ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0'}`} data-id="element-241">
              <p className="text-brown-text/80 pl-8 leading-relaxed" data-id="element-242">{faq.a}</p>
            </div>
          </div>)}
      </div>
    </Section>;
};
export const FinalCTA = () => <Section className="bg-gradient-to-b from-pink-light to-celeste-light text-center relative overflow-hidden" data-id="element-243">
    <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-244"></div>

    <FadeIn className="relative z-10 max-w-3xl mx-auto" data-id="element-245">
      <h2 className="text-5xl md:text-6xl font-bold text-pink-deep mb-8 font-heading" data-id="element-246">
        ¿Y a vos, quién te cuida?
      </h2>

      <div className="text-xl md:text-2xl italic text-brown-text/90 space-y-3 mb-8" data-id="element-247">
        <p data-id="element-248">Diste tanto en estos meses.</p>
        <p data-id="element-249">Tu cuerpo. Tu sueño. Tu energía. Tu tiempo.</p>
        <p className="font-bold text-pink-deep mt-6" data-id="element-250">Hoy es tu turno.</p>
        <p data-id="element-251">No para ser menos mamá.</p>
        <p className="font-bold" data-id="element-252">Sino para ser una mamá completa.</p>
      </div>

      <div className="bg-white/60 backdrop-blur-sm p-6 rounded-3xl border border-white shadow-sm mb-8" data-id="element-253">
        <p className="text-2xl font-bold text-celeste-deep mb-2" data-id="element-254">
          La paz que buscás existe.
        </p>
        <p className="text-2xl font-bold text-celeste-deep mb-2" data-id="element-255">
          El camino para encontrarla también.
        </p>
        <p className="text-3xl font-bold text-pink-deep mt-3" data-id="element-256">Y empieza hoy.</p>
      </div>

      <Button className="w-full sm:w-auto text-xl py-6 px-10 mb-4 shadow-xl" data-id="element-257">
        〔 🌸 QUIERO MI RENACER — ACCEDER AHORA 〕
      </Button>

      <p className="text-sm font-medium text-brown-text/70 mb-10" data-id="element-258">
        Acceso inmediato · $19.999 ARS · Garantía 7 días
      </p>

      <FloralSeparator data-id="element-259" />

      <p className="italic text-pink-deep font-medium mt-6" data-id="element-260">
        🌸 Renacer Después del Parto — Porque la maternidad no debería doler en
        silencio.
      </p>
    </FadeIn>
  </Section>;
export const Footer = () => <footer className="bg-cream py-6 text-center text-sm text-brown-text/50 border-t border-pink-border/30" data-id="element-261">
    <p data-id="element-262">© 2025 — Renacer Después del Parto. Todos los derechos reservados.</p>
  </footer>;